var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogleClassroomIcon = function SvgGoogleClassroomIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#51A329",
    d: "M1.818 3.182h16.364v13.636H1.818z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#A3E084",
    d: "M13.636 10.454a1.023 1.023 0 1 0 0-2.046 1.023 1.023 0 0 0 0 2.046m0 .682c-1.094 0-2.272.58-2.272 1.3v.746h4.545v-.746c0-.72-1.178-1.3-2.273-1.3m-7.272-.681a1.023 1.023 0 1 0-.001-2.047 1.023 1.023 0 0 0 0 2.046zm0 .681c-1.095 0-2.273.58-2.273 1.3v.746h4.545v-.746c0-.72-1.178-1.3-2.272-1.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10 9.545a1.363 1.363 0 1 0 0-2.727 1.363 1.363 0 1 0 0 2.727m0 .91c-1.534 0-3.182.814-3.182 1.818v.909h6.364v-.91c0-1.003-1.648-1.818-3.182-1.818zM11.818 15.91h4.091v.908h-4.09z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC033",
    d: "M18.636 1.364H1.364C.61 1.364 0 1.974 0 2.727v14.546c0 .753.61 1.363 1.364 1.363h17.272c.754 0 1.364-.61 1.364-1.363V2.727c0-.754-.61-1.363-1.364-1.363m-.454 15.454H1.818V3.182h16.364z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.636 1.364H1.364C.61 1.364 0 1.974 0 2.727v.114c0-.754.61-1.364 1.364-1.364h17.272c.754 0 1.364.61 1.364 1.364v-.114c0-.754-.61-1.363-1.364-1.363M1.818 16.818h16.364v.114H1.818z",
    opacity: 0.2
  })));
};
export { SvgGoogleClassroomIcon as ReactComponent };